import React from 'react';
import { Link } from "react-router-dom";
import * as Backend from "../backend.js";
import * as util from "../other/util.js";
import ShipCollection from "../share/ship-collection.js";

// A list with all available ship designs for the player
class ShipDesignsOverview extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = { ship_designs: [] };
    }

    refreshState() {
        Backend.getShipDesigns((res) => {
            if (res.success) {
                this.setState({ ship_designs: res.ship_designs });
            }
        });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        return (
            <div className="fade-in" key={Math.random()}>
                <h1>Ship Designs</h1>
                <table className="generic-list">
                    <thead style={{ fontSize: "14px" }}>
                        <tr>
                            <td>Name</td>
                            <td>Attack</td>
                            <td>Hull Points</td>
                            <td>Armor</td>
                            <td>Shield</td>
                            <td>Thrust</td>
                            <td>Cargo</td>
                            <td>Acceleration</td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.ship_designs.map((ship_design) => (this.renderShipDesign(ship_design)))}
                    </tbody>
                </table>
                <br />
                <util.JsonDebug obj={this.state.ship_designs} />
            </div>
        );
    }

    renderShipDesign(ship_design) {
        const pseudo_fleet = new ShipCollection();
        pseudo_fleet.addShips(ship_design, 1);

        return (
            <tr key={ship_design.id}>
                <td><Link className="link-button-menu" to={{ pathname: "/game/ship-design/" + ship_design.id, force_update: true }}>{ship_design.name}</Link></td>
                <td>{ship_design.stats.attack}</td>
                <td>{ship_design.stats.structure}</td>
                <td>{ship_design.stats.armor}</td>
                <td>{ship_design.stats.shield}</td>
                <td>{ship_design.stats.thrust}</td>
                <td>{ship_design.stats.cargo}</td>
                <td>{pseudo_fleet.stats.acceleration}</td>
            </tr>
        );
    }
}

export default util.withNavigation(ShipDesignsOverview);